//
import { useQuery } from "@tanstack/react-query";
import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
// import { TableHeaderType, TableRowItem } from "@/components/tables/types";
import { RelativeComponentLoader } from "@/components/loader";
import { getComputePoolsMetadata, getComputePoolsSummary } from "@/helpers/apis";
// import { ComputePoolMetadataItem } from "./types";
// import { Link } from "react-router-dom";
// import dayjs from "dayjs";
import { DateRange } from "@/components/dateRange";
import {
  getDateByEndOfDayWithoutTimeoffset,
  getDateByStartOfDayWithoutTimeoffset,
} from "@/components/dateRange/utils";
import { useDateFromSearchParams } from "@/helpers/useTimeHooks";
import SummaryCards from "./components/SummaryCards";
import DailyCostGraphs from "./components/DailyCostGraphs";
import MetadataTable from "./components/MetadataTable";
import { useBreadcrumb } from "@/components/breadcrumbs";

// moved to components/MetadataTable.tsx

const ComputePoolsDashboard = () => {
  useBreadcrumb("Compute Pools");
  const { startDate, endDate, onUpdate } = useDateFromSearchParams();
  const isoStart = getDateByStartOfDayWithoutTimeoffset(startDate).toISOString();
  const isoEnd = getDateByEndOfDayWithoutTimeoffset(endDate)!.toISOString();
  const { data: summary, isLoading: isSummaryLoading } = useQuery({
    queryKey: ["compute-pools-summary", isoStart, isoEnd],
    queryFn: () => getComputePoolsSummary({ start_date: isoStart, end_date: isoEnd }),
  });
  const { data: metadata, isLoading: isMetadataLoading } = useQuery({
    queryKey: ["compute-pools-metadata", isoStart, isoEnd],
    queryFn: () => getComputePoolsMetadata({ start_date: isoStart, end_date: isoEnd }),
  });

  // Hooks must be declared before any conditional returns
  // No manual average computation needed; backend now provides summary

  if (isSummaryLoading || isMetadataLoading)
    return <RelativeComponentLoader label="Loading compute pools..." />;

  const poolNames = (metadata || []).map(m => m.name).filter(Boolean) as string[];

  return (
    <div className="al-p-6 al-space-y-6">
      <Stack justify={"between"} align={"center"}>
        <Typography variant="page-heading">Compute Pools</Typography>
        <DateRange
          startDate={startDate}
          endDate={endDate}
          availableStaticRanges={["Last 7 days", "Last 28 days"]}
          onDateRangeSelect={onUpdate}
        />
      </Stack>
      <SummaryCards summary={summary} />
      <DailyCostGraphs
        poolNames={poolNames}
        startDate={startDate}
        endDate={endDate}
        defaultSelected={poolNames}
      />
      <Stack direction={"column"} className="p-3 al-bg-white al-rounded-md">
        <Stack direction={"row"} justify={"between"}>
          <h3 className={"al-text-xl al-font-medium"}>Compute Pools</h3>
        </Stack>
        <MetadataTable items={metadata || []} />
      </Stack>
    </div>
  );
};

export default ComputePoolsDashboard;
